"use client";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="powered-by" className="relative overflow-hidden">
      {/* Banner image — full width */}
      <div
        aria-label="INJAZ Al-Arab"
        role="img"
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: "url('/images/landing/about-injaz-banner.png')" }}
      />
      {/* Dark scrim for legibility */}
      <div className="absolute inset-0 bg-gradient-to-b from-secondary/70 via-secondary/65 to-secondary/80" />

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 container mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-36 flex flex-col items-center text-center"
      >
        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.45, delay: 0.15 }}
          className="text-3xl md:text-4xl font-bold text-white"
        >
          About{" "}
          <a
            href="https://www.injazalarab.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-journey-1 hover:underline"
          >
            INJAZ Al-Arab
          </a>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.45, delay: 0.28 }}
          className="mx-auto text-center text-white/90 max-w-2xl mt-5 leading-relaxed text-base md:text-lg"
        >
          INJAZ was built on one simple idea — young people deserve learning that means something.
          Through our students, educators, volunteers, and partners, we create experiences that
          connect to real life. This program carries that same spirit, giving you the tools to make
          smarter choices and step confidently into what&apos;s next.
        </motion.p>

        <motion.a
          href="https://www.injazalarab.org/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.45, delay: 0.4 }}
          className="mt-8 inline-flex px-6 py-2.5 rounded-full border border-white/40 bg-white/10 text-white text-sm font-medium hover:bg-white/25 hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-all duration-150 backdrop-blur-sm"
        >
          Explore INJAZ Al-Arab
        </motion.a>
      </motion.div>
    </section>
  );
}
